import React, { ReactElement, useEffect, useState } from "react";
import styled from "styled-components";
import DashboardNavbar from "../../navbar/dashboard-navbar";
import DashboardSidebar from "../../navbar/dashboard-sidebar";
import { Colors } from "../../../utils/colors";
import { useSelector } from "react-redux";
import { RootState } from "redux/app/store";
import { isTokenExpired } from "utils/jwt";
import { LogOut } from "services/user/logOut";

interface IProps {
  children?: JSX.Element | string;
  tint?: string[];
}
const DashboardLayout = ({ children, tint }: IProps) => {
  const [openSidebar, setOpenSidebar] = useState(false);

  useEffect(() => {
    if (openSidebar) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [openSidebar]);

  useEffect(() => {
    setTimeout(() => {
      if (isTokenExpired()) {
        LogOut();
      }
    }, 1000);
  }, []);

  return (
    <Container>
      <Navbar>
        <DashboardNavbar setOpenSidebar={(bol) => setOpenSidebar(bol)} />
      </Navbar>
      <Body>
        <Sidebar isopen={openSidebar ? "true" : "false"}>
          <DashboardSidebar />
        </Sidebar>
        <Content>
          {tint && (
            <TintContainer>
              <UpwardTint colora={tint[0]} colorb={tint[1]}></UpwardTint>
            </TintContainer>
          )}
          <Children> {children}</Children>
        </Content>
      </Body>
    </Container>
  );
};

export default DashboardLayout;

const Container = styled.main`
  width: 100vw;
  height: 100vh;
  max-width: 1920px;

  /* overflow: hidden; */
`;
const Navbar = styled.div`
  height: 8%;
`;

const Sidebar = styled.div<{ isopen: string }>`
  width: 18%;
  position: relative;
  @media only screen and (max-width: 769px) {
    width: 100%;
    position: absolute;
    top: -0.1%;
    z-index: 10;
    height: ${(props) => (props.isopen === "true" ? "120%" : "100%")};
    transform: ${(props) =>
      props.isopen === "true" ? "translateX(0)" : "translatex(-100%)"};

    transition: all ease-in 0.2s;
  }
`;
const Body = styled.div`
  display: flex;
  width: 100%;
  max-height: 92%;
  position: relative;
`;

const Content = styled.div`
  background-color: ${Colors.grey900};
  width: 82%;
  height: 92vh;
  max-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 4.2rem 6.4rem;
  position: relative;

  @media only screen and (max-width: 769px) {
    width: 100%;
    padding: 2.4rem;
  }
`;

const Children = styled.div`
  position: relative;
`;
const TintContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 55rem;
  top: 0;
  left: 0;
  @media only screen and (max-width: 769px) {
    height: 40rem;
  }
`;

const UpwardTint = styled.div<{ colora?: string; colorb?: string }>`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: ${(props) => (props.colorb ? props.colorb : "transparent")};
  background: ${(props) =>
    `linear-gradient(180deg, ${props.colorb} 0%,  ${props.colora} 72%, ${Colors.grey900} 100%)`};
  opacity: 0.3;
`;
